import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src3121536383/src/next-app/app/(authenticated)/[workspace]/client.tsx");
